import React from 'react';
import { ReferralExportForm } from '../components/ReferralExportForm';

export const DataPage: React.FC = () => {
  return (
    <>
      <div className="data-page-header">
        <h2>Data</h2>
        <p className="data-page-subtitle">Export referral data for analysis and forecasting.</p>
      </div>
      <ReferralExportForm />
    </>
  );
};
